// extracted by mini-css-extract-plugin
module.exports = {"container":"DotBadge_container__xl5Oa","small":"DotBadge_small__GxB_V","medium":"DotBadge_medium__ciNJr"};